import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------payment page api's-------------------------------->
    /**
     * payment index page api
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getPayments(page, count, search, status, sort, label, from_date, to_date, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/payment/' + page + '/' + count + '?search=' + search + '&status=' + status + '&from_date=' + from_date + '&to_date=' + to_date + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    getPaymentsExport(page, count, search, status, sort, label, from_date, to_date, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/payment/export/' + page + '/' + count + '?search=' + search + '&status=' + status + '&from_date=' + from_date + '&to_date=' + to_date + '&sort=' + sort + '&label=' + label + '&custom=' + custom)
    },
    postPaymentdetails(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/details', data)
    },
    /**
     * create api 
     * @param {*} form 
     */
    postPaymentReceive(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/create', form)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getPaymentReceive(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/payment/view/' + id)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getPaymentReceiveView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/payment/viewpage/' + id)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postPaymentReceiveUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/update/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getPaymentReceiveDelete(data, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/singledelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postPaymentRefundUpdate(id, form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/paymentRefund/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postPaymentRefundDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/refunddelete/' + id)
    },
    /**
     * 
     * @param {*} data 
     */
    postFiltercreatePayment(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpatePayment(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeletePayment(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/filterdelete', data)
    },
    /**
     * bulk delete api 
     */
    postPaymentBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/payment/bulkdelete', data)
    },

}